module.exports = ( $compile, $parse, $sce, $q, Api, DataConcierge, populateTemplateURLFilter, settings ) ->
  return {
    scope:
      manualStep:          "="
      dataconcierge:       "="
      requestSupport:      "&"
      manualUploads:       "="
      query:               "="
      manualSelected:      "="
      uploadDoc:           "&"
      checkComplete:       "&"
      isDisabled:          "&manualStepIsDisabled"

    link: (scope, element, attrs) ->
      scope.checkComplete = if scope.checkComplete() != false then scope.checkComplete else false
      scope.onRequestClicked = () ->
        if scope.manualStep.request
          $q.when( scope.manualStep.request ).then () ->
            DataConcierge.showRequestModal( scope.manualStep.request )
        else
          if angular.isFunction(scope.requestSupport) then scope.requestSupport()


      scope.makeFileList = (list) ->
        ret = ''
        if list
          for file in list
            ret += file.title + "<br>"
          $sce.trustAsHtml(ret)

      scope.isState = (step, state) ->
        step.state == state

      scope.toggleState = (step, state) ->
        if step.state == state
          step.state = 'incomplete'
        else
          step.state = state

        new Api.ManualWorkflowStepIteration( id:step.id, state:step.state ).$update()
        scope.$root.$broadcast('manual source state changed', step )

      scope.getRequestStatus = () ->
        if !scope.manualStep.request?
          return 'No request'
        else if scope.manualStep.request.completed_date?
          return 'Complete'
        else
          return 'Open'

      appendURLParameter = ( url, parameter ) ->
        connector = if url.includes("?") then "&" else "?"
        return url + connector + encodeURI(parameter)

      scope.getManualSourceURL = () ->
        params = {'query': scope.query, 'workflow_step': scope.manualStep.workflow_step}
        url = populateTemplateURLFilter(scope.manualStep.link, params)

        return url

      scope.openManualSourceURLWithoutHarmonia = () ->
        window.open scope.getManualSourceURL(), "_blank"

      scope.openManualSourceURL = () ->
        scope.openManualSourceURLWithoutHarmonia()
        return true

    template: require('./manualstep.html')
  }
